import React from 'react'
import Image from 'next/image'

interface TopicMemesProps {
  heading: string
  description: React.ReactNode
  imageFolder: string
}

const TopicMemes: React.FC<TopicMemesProps> = ({
  heading,
  description,
  imageFolder,
}) => {
  const [images, setImages] = React.useState<string[]>([])

  React.useEffect(() => {
    const fetchImages = async () => {
      const response = await fetch(`/api/image?folder=${imageFolder}`)
      const fetchedImages = await response.json()
      setImages(fetchedImages)
    }
    fetchImages()
  }, [imageFolder])

  return (
    <div className='container mx-auto px-4 py-12 sm:py-16'>
      <h1 className='mb-6 text-center text-4xl font-bold'>{heading}</h1>
      <div className='mb-6 text-center text-xl'>{description}</div>
      <div className='columns-1 gap-4 sm:columns-2 lg:columns-3'>
        {images.map((image, index) => (
          <div key={index} className='mb-4 break-inside-avoid'>
            <Image
              src={`/${imageFolder}/${image}`}
              alt={`Meme ${index + 1}`}
              width={500}
              height={500}
              className='h-auto w-full rounded-lg'
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default TopicMemes
